const BASE_URL: string = process.env.REACT_APP_API_KEY || '';

export const FIND_MANY_BRAND: string = BASE_URL + "/products/brand/find-many"
export const CREATE_BRAND : string = BASE_URL + "/products/brand/create"
export const UPDATE_BRAND : string = BASE_URL + "/products/brand/update?id="
export const DELETE_BRAND : string = BASE_URL + "/products/brand/delete?id="